import _ from "lodash";
import React from "react";
import classes from "./DropDown.scss";
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";
import ACLStore from "lib/aclStore";
import {
  SNPv2_ACCESS_PERMISSION,
  ENABLE_ASSESSMENTS_IN_PYP,
} from "Constants/permissionConstants";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getOrganizationDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { isMapleBearLikeEducator } from "Courses/modules/utils";
import { getIsCurrentAcademicYear } from "Platform/modules/PlatformModule";
import {
  ASSESSMENT_TYPE_AI_TUTOR,
  CURRICULUM_TYPE_PYP,
} from "Constants/stringConstants";
import { WORKSHEET_TEMPLATES } from "Worksheet/modules/WorksheetConstants";
import {
  findCountryUser,
  isGlobalUser,
} from "routes/routes/Teacher/routes/Courses/modules/utils";
import {
  getDisableEditUnitFlowResourcesPermValue,
  getDisableDeleteUnitFlowResourcesPermValue,
  getIsProSchool,
} from "UnitPlans/modules/Utils";
import { Dropdown, DropdownMenu, IconButton } from "@toddle-edu/ds-web";
import {
  CopyOutlined,
  DeleteOutlined,
  DotsHorizontalOutlined,
  DotsVerticalOutlined,
  PencilLineOutlined,
  PrintOutlined,
  ReloadArrowOutlined,
  StudentShareOutlined,
  TagOutlined,
} from "@toddle-edu/ds-icons";
import ACLStorage from "lib/aclService";
import { getIsGradingPeriodUnlocked } from "GradingSetup/modules/Utils";

const checkCustomPermission = ({ key, customPermissionParams }) => {
  switch (key) {
    case "TAG_SNP": {
      const { totalNewSnpCycles } = customPermissionParams;

      const isModuleEnabled = ACLStorage.getModuleSettingsValue(
        SNPv2_ACCESS_PERMISSION
      );

      return isModuleEnabled && totalNewSnpCycles > 0;
    }
    default:
      return true;
  }
};

const DropDown = ({
  item,
  centralRepoConfig = {},
  onDeleteClick,
  onEditClick,
  onDuplicateClick,
  onPrintClick,
  onAssignToStudentClick,
  curriculumType,
  updateTagAssessmentId,
  totalNewSnpCycles,
  disableAssignToStudents,
  getIsCurrentAcademicYear,
  assessmentTypeLabel,
  isTermsExists,
  assessmentType,
  onChangeTaskTypeClick,
  isUnitFlowRevamp,
  testId,
}) => {
  const { t } = useTranslation(["common", "classRoom"]);

  const notCurrentAcademicYear = !getIsCurrentAcademicYear();
  const {
    shouldDisableEdit = false,
    shouldDisableDelete = false,
    isGlobalOrCountryUser,
  } = centralRepoConfig;
  const isWorksheet = _.includes(
    WORKSHEET_TEMPLATES,
    _.get(item, "templateId", "")
  );
  const isGradingPeriodUnlocked = getIsGradingPeriodUnlocked(
    _.get(item, "academicTerm"),
    assessmentType
  );
  const isProSchool = getIsProSchool();

  const filteredMenuItemsWithLocaleChange = (menuItems, t, curriculumType) => {
    const menus = [];
    _.forEach(menuItems, element => {
      const { label, perm, customPermissionParams, key } = element;
      const isItemAllowedByPerm = !perm || ACLStore.can(perm, "all");
      const isItemAllowedByCustomPermission = checkCustomPermission({
        key,
        customPermissionParams,
      });

      if (
        isItemAllowedByPerm &&
        isItemAllowedByCustomPermission &&
        !element.shouldHide &&
        !item.shouldHide &&
        !_.includes(item.curriculumsToExclude, curriculumType)
      ) {
        menus.push({ ...element, label: t(label) });
      }
    });
    return menus;
  };

  const menuItems = [
    {
      label: "edit",
      key: "edit",
      disabled: shouldDisableEdit && getDisableEditUnitFlowResourcesPermValue(),
      curriculumsToExclude: [],
      icon: <PencilLineOutlined variant="subtle" />,
    },
    {
      label: "duplicate",
      key: "duplicate",
      disabled: false,
      curriculumsToExclude: [],
      icon: <CopyOutlined variant="subtle" />,
    },
    {
      label: "print",
      key: "print",
      disabled: false,
      curriculumsToExclude: [],
      shouldHide:
        isWorksheet || ACLStore.can("FeatureFlag:PreventPrintAndScreenshots"),
      icon: <PrintOutlined variant="subtle" />,
    },
    {
      label: "assign_to_students",
      key: "assign_to_students",
      disabled:
        disableAssignToStudents ||
        notCurrentAcademicYear ||
        !isTermsExists ||
        !isGradingPeriodUnlocked,
      shouldHide: isGlobalOrCountryUser || isProSchool,
      curriculumsToExclude: [],
      disabledTooltip: !isGradingPeriodUnlocked
        ? t("academicSetup:you_cannot_make_changes_to_assignment_since_locked")
        : !isTermsExists
        ? t(
            "classRoom:assign_to_students_no_grading_periods_tooltip_with_label_plural",
            {
              label: assessmentTypeLabel,
            }
          )
        : null,
      icon: <StudentShareOutlined variant="subtle" />,
    },
    {
      key: "CHANGE_TASK",
      label: "change_task_type",
      disabledTooltip: t(
        "classRoom:change_task_type_dropdown_disabled_tooltip"
      ),
      disabled:
        assessmentType === ASSESSMENT_TYPE_AI_TUTOR ||
        assessmentType === "worksheet",
      icon: <ReloadArrowOutlined variant="subtle" />,
      shouldHide:
        curriculumType === CURRICULUM_TYPE_PYP &&
        !ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP),
      perm: "FeatureFlag:ChangeTaskType",
    },
    {
      label: "tag_snp",
      key: "TAG_SNP",
      disabled: false,
      shouldHide:
        ACLStorage.getModuleSettingsValue(SNPv2_ACCESS_PERMISSION) === false,
      customPermissionParams: { totalNewSnpCycles },
      curriculumsToExclude: [],
      icon: <TagOutlined variant="subtle" />,
    },
    {
      label: "delete",
      key: "delete",
      isDestructive: true,
      disabled:
        shouldDisableDelete && getDisableDeleteUnitFlowResourcesPermValue(),
      curriculumsToExclude: [],
      icon: <DeleteOutlined variant="subtle" />,
    },
  ];

  const itemId = _.get(item, "id", "");

  const onDropdownClick = action => {
    switch (action) {
      case "edit":
        onEditClick({ id: item.id, mode: "edit" });
        break;
      case "duplicate":
        onDuplicateClick(item);
        break;
      case "print":
        onPrintClick(item);
        break;
      case "delete":
        onDeleteClick(item);
        break;
      case "assign_to_students":
        onAssignToStudentClick(item);
        break;
      case "TAG_SNP":
        updateTagAssessmentId(itemId);
        break;
      case "CHANGE_TASK":
        onChangeTaskTypeClick(item);
        break;
      default:
        return null;
    }
  };

  return (
    <div className={classes.container}>
      <Dropdown
        placement={"bottomRight"}
        overlay={
          <DropdownMenu
            dsVersion={isUnitFlowRevamp ? "2.0" : "1.0"}
            options={filteredMenuItemsWithLocaleChange(
              menuItems,
              t,
              curriculumType
            )}
            onClick={({ key }) => {
              onDropdownClick(key);
            }}
            shouldStopPropagation={true}
            testId={testId}
          />
        }
      >
        <IconButton
          onClick={e => {
            e.stopPropagation();
          }}
          size={"small"}
          icon={
            isUnitFlowRevamp ? (
              <DotsVerticalOutlined />
            ) : (
              <DotsHorizontalOutlined />
            )
          }
          variant={"plain"}
          testId={`${testId}-dropDownMenu`}
        />
      </Dropdown>
    </div>
  );
};
const mapActionCreators = {
  getIsCurrentAcademicYear,
};

const mapStateToProps = (state, ownProps) => {
  const disableAssignToStudents = !_.get(ownProps, "params.course_id", null);
  const { item = {} } = ownProps;
  const { isImported = false } = item;
  const organizationId = state.login.userInfo.org_id;
  const organizationDetails = getOrganizationDetailsFromCache(organizationId);
  const organizationTags = _.get(organizationDetails, "tags", []);
  const isEducator = isMapleBearLikeEducator({ organizationTags });
  const shouldDisableActionsForEducator = isImported && isEducator;
  const userTags = _.get(state, "login.userInfo.tags", []);
  const isGlobalOrCountryUser = Boolean(
    isGlobalUser({ userTags }) || findCountryUser({ userTags })
  );
  const centralRepoConfig = {
    shouldDisableEdit: shouldDisableActionsForEducator,
    shouldDisableDelete: shouldDisableActionsForEducator,
    isGlobalOrCountryUser: isGlobalOrCountryUser,
  };

  return {
    centralRepoConfig,
    disableAssignToStudents,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapActionCreators)
)(DropDown);
